import { useAdminCompanyTrainingPhotos } from 'app/javascript/queries/useAdmin';
import AdminPanel from 'app/javascript/components/admin/AdminPanel';
import TrainingPhotoCard from 'app/javascript/components/admin/company_health/TrainingPhotoCard';

// The API caps this at PHOTOS_LIMIT (20) — the caption below says so, because a
// truncated grid with no note reads as "this is everything".
export default function TrainingPhotosGrid({ slug }: { slug: string }) {
  const { data, isLoading, isError } = useAdminCompanyTrainingPhotos(slug);
  const photos = data ?? [];

  return (
    <div className="space-y-2">
      <AdminPanel
        isLoading={isLoading}
        isError={isError}
        isEmpty={photos.length === 0}
        emptyMessage="Esta academia ainda não enviou fotos de treino."
      >
        <div className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3 lg:grid-cols-4">
          {photos.map((photo) => (
            <TrainingPhotoCard key={photo.id} photo={photo} />
          ))}
        </div>
      </AdminPanel>
      {photos.length > 0 && (
        <p className="text-xs text-muted-foreground">
          {photos.length === 1 ? 'Única foto enviada.' : `As ${photos.length} fotos mais recentes.`}
        </p>
      )}
    </div>
  );
}
